export enum CHANNEL_TYPE {
  GROUP = 'group',
  SUPERGROUP = 'supergroup',
  BROADCAST = 'broadcast',
}
